import React from 'react';
import { facts } from '../../data/facts';

const ProofStrip = () => (
  <section className="py-12 bg-white border-b border-gray-200" aria-label="Program reach">
    <div className="dr-container text-center">
      <p className="text-4xl md:text-5xl font-black text-navy mb-2">{facts.studentsReach}</p>
      <p className="text-lg md:text-xl text-gray-700 max-w-prose mx-auto">
        {facts.studentsContext}
      </p>
      <p className="text-sm text-gray-500 mt-3 max-w-prose mx-auto">{facts.studentsNote}</p>
    </div>
  </section>
);

export default ProofStrip;
